import { withInstall } from '@sgui-plus/utils/with-install'
import Progress from './src/progress.vue'

export const SgProgress = withInstall(Progress)
export default SgProgress

export * from './src/progress'
